import henceforthLogo from "../../../assets/henceforth.png";

const NosPartenaires = () => {
  return (
    <div className="py-4" style={{ backgroundColor: "#21354D" }}>
      <div
        className="container d-flex flex-column align-items-center"
        style={{
          marginTop: "6em",
          marginBottom: "6em",
        }}
      >
        <h1
          className="display-4 text-uppercase mb-5"
          style={{ color: "white" }}
        >
          nos <span style={styleSpan}>Partenaires</span>
        </h1>
        <div
          className="d-flex justify-content-around align-items-center"
          style={{ width: "100%" }}
        >
          <CrisisLogo />
          <img src={henceforthLogo} style={{ width: "15em" }} alt="" />
        </div>
      </div>
    </div>
  );
};

const CrisisLogo = () => {
  return (
    <svg
      height="5em"
      viewBox="0 0 68 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-1253.000000, -718.000000)"
          fill="#FFFFFF"
        >
          <g
            id="BW-LOGO-CRISIS-"
            transform="translate(1238.000000, 656.000000)"
          >
            <g id="Group" transform="translate(15.447697, 62.565086)">
              <g
                transform="translate(17.814780, 2.132415)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="14.042085 1.92360044 13.3961491 2.82163308 11.1811341 1.22975624 2.84228321 1.22975624 0.907118691 2.9562719 0.076157661 2.21600621 2.42052505 0.123735549 11.5379682 0.123735549"></polygon>
              </g>
              <g
                transform="translate(17.814780, 16.019706)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="14.042085 1.06951127 11.5379682 2.86937617 2.42052505 2.86937617 0.076157661 0.758437791 0.907944696 0.017346105 2.84228321 1.76335547 11.1811341 1.76335547 13.3961491 0.171478638"></polygon>
              </g>
              <g
                transform="translate(0.081774, 14.266263)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="12.885678 1.80977696 11.7388527 2.83187554 2.62240067 2.83187554 0.11729271 1.03168025 0.763889424 0.134308413 2.97890443 1.72568965 11.3172597 1.72568965 12.054717 1.06818967"></polygon>
              </g>
              <g
                transform="translate(0.081774, 3.904691)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="12.885678 1.16384105 12.054717 1.90542833 11.3172597 1.24792835 2.97890443 1.24792835 0.763889424 2.83930959 0.11729271 1.94193776 2.62240067 0.141742458 11.7388527 0.141742458"></polygon>
              </g>
              <g
                transform="translate(23.788944, 9.178237)"
                fill-rule="nonzero"
                id="Shape"
              >
                <path d="M0.023293341,1.22331341 L0.576386289,1.22331341 L0.576386289,0.118449117 L0.023293341,0.118449117 L0.023293341,1.22331341 Z M0.023293341,2.59778573 L0.576386289,2.59778573 L0.576386289,1.49159983 L0.023293341,1.49159983 L0.023293341,2.59778573 Z"></path>
              </g>
              <g
                transform="translate(15.717388, 4.248639)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="8.094849 5.04804696 8.094849 6.15291125 8.64794195 6.15291125 8.64794195 6.42119767 8.094849 6.42119767 8.094849 7.52738357 8.64794195 7.52738357 8.64794195 7.87034084 6.4762096 9.84829241 5.13956831 8.80983893 3.19696975 10.5409802 2.36468711 11.2824023 1.55668902 12.0023483 0.945445323 12.5471812 0.481726116 12.1351699 0.112997484 11.8070807 0.725727993 11.2620826 5.09083402 7.37292063 6.41938046 8.40460088 7.54175605 7.38233709 7.54175605 5.19177183 6.41938046 4.16967324 5.04474294 5.23505449 0.724406385 1.38521039 0.112997484 0.840212286 0.480404508 0.5121231 0.943958514 0.100111806 1.55536742 0.645109905 2.36468711 1.36621227 3.19564814 2.10631275 5.09347723 3.79813619 6.47753121 2.7258165 8.64794195 4.70376807 8.64794195 5.04804696"></polygon>
              </g>
              <g
                transform="translate(5.587924, 16.771206)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="10.242462 0.766202238 9.6310531 1.31120034 6.37758461 4.21080829 0.09581658 4.21080829 0.09581658 3.10462239 5.95599165 3.10462239 8.80009207 0.569613048 9.41150097 0.024614949 9.87505498 0.438113052"></polygon>
              </g>
              <g
                transform="translate(5.587924, 0.079462)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="10.242462 3.52770215 9.87373337 3.85579134 9.41150097 4.26928944 9.41017936 4.26928944 8.79877046 3.72429134 5.95599165 1.19060361 0.09581658 1.19060361 0.09581658 0.084417711 6.37758461 0.084417711 9.6310531 2.98270406"></polygon>
              </g>
              <g
                transform="translate(24.446609, 9.868612) scale(-1, 1) translate(-24.446609, -9.868612) translate(23.703205, 9.290409)"
                id="Rectangle"
              >
                <rect
                  x="0.023293341"
                  y="0.005616834"
                  width="1.354483"
                  height="1.1060207"
                ></rect>
              </g>
              <g
                transform="translate(24.446609, 11.211696) scale(-1, 1) translate(-24.446609, -11.211696) translate(23.703205, 10.550892)"
                id="Rectangle"
              >
                <rect
                  x="0.023293341"
                  y="0.118779519"
                  width="1.354483"
                  height="1.1060207"
                ></rect>
              </g>
              <g
                transform="translate(7.881409, 0.033040)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="7.764447 5.2200212 1.79556967 10.5393282 7.94947212 16.0223494 8.31753995 16.3504386 8.78125916 16.7634411 12.2357773 19.8426225 18.0964479 19.8426225 18.0964479 20.9486432 11.8140191 20.9486432 7.94947212 17.5045328 7.58156949 17.1762784 7.11851109 16.7634411 7.11785029 16.7634411 5.69761729 15.4981666 4.86665626 14.7570749 0.133482408 10.5393282 4.86665626 6.32158147 4.86665626 6.32092066 5.69761729 5.58065498 7.11702428 4.31521532 7.11785029 4.31521532 7.58090869 3.90237802 7.94881132 3.57428884 11.8140191 0.130673991 18.0964479 0.130673991 18.0964479 1.23685989 12.2357773 1.23685989 8.78059835 4.31521532 8.31671394 4.72821782 7.94881132 5.05630701"></polygon>
              </g>
              <g
                transform="translate(9.533419, 5.120735)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="6.112437 0.132326001 4.41433592 1.64688877 0.143559669 5.451633"></polygon>
              </g>
              <g
                transform="translate(11.146772, 7.433880)"
                fill-rule="nonzero"
                id="Shape"
              >
                <path d="M1.817211,3.1384886 L2.51584603,3.76096597 L2.51584603,2.51601123 L1.817211,3.1384886 Z M3.62186672,6.2280777 L0.154628136,3.1384886 L3.62186672,0.049229898 L3.62186672,6.2280777 Z"></path>
              </g>
              <g
                transform="translate(33.916757, 5.723058)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="4.295226 0.117953514 5.34673036 1.16945788 5.34673036 2.92207529 3.94466948 2.92207529 3.94466948 1.5200144 1.49110423 1.5200144 1.49110423 8.17959711 3.94466948 8.17959711 3.94466948 6.77753623 5.34673036 6.77753623 5.34673036 8.53015364 4.295226 9.581658 1.1407129 9.581658 0.08920854 8.53015364 0.08920854 1.16945788 1.1407129 0.117953514"></polygon>
              </g>
              <g
                transform="translate(40.969848, 5.782035)"
                fill-rule="nonzero"
                id="Shape"
              >
                <path d="M3.96812802,1.46103764 L1.51456277,1.46103764 L1.51456277,3.9144377 L3.96812802,3.9144377 L3.96812802,1.46103764 Z M4.31868454,0.058976757 L5.37018891,1.11048112 L5.37018891,4.26515942 L4.31868454,5.31666378 L5.37018891,9.52268124 L3.96812802,9.52268124 L2.91662365,5.31666378 L1.51456277,5.31666378 L1.51456277,9.52268124 L0.112667082,9.52268124 L0.112667082,0.058976757 L4.31868454,0.058976757 Z"></path>
              </g>
              <g
                transform="translate(48.861500, 10.572864) scale(-1, 1) translate(-48.861500, -10.572864) translate(48.118095, 5.782035)"
                id="Rectangle"
              >
                <rect
                  x="0.064758792"
                  y="0.058976757"
                  width="1.40189569"
                  height="9.46370449"
                ></rect>
              </g>
              <g
                transform="translate(51.263192, 5.723058)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="4.295226 0.117953514 5.34673036 1.16945788 5.34673036 2.57151877 3.94466948 2.57151877 3.94466948 1.5200144 1.49110423 1.5200144 1.49110423 3.97357965 4.295226 3.97357965 5.34673036 5.02508402 5.34673036 8.53015364 4.295226 9.581658 1.1407129 9.581658 0.08920854 8.53015364 0.08920854 7.12809275 1.49110423 7.12809275 1.49110423 8.17959711 3.94466948 8.17959711 3.94466948 5.37564054 1.1407129 5.37564054 0.08920854 4.32413618 0.08920854 1.16945788 1.1407129 0.117953514"></polygon>
              </g>
              <g
                transform="translate(59.062662, 10.572864) scale(-1, 1) translate(-59.062662, -10.572864) translate(58.236657, 5.782035)"
                id="Rectangle"
              >
                <rect
                  x="0.085078515"
                  y="0.058976757"
                  width="1.40189569"
                  height="9.46370449"
                ></rect>
              </g>
              <g
                transform="translate(61.525808, 5.723058)"
                fill-rule="nonzero"
                id="Path"
              >
                <polygon points="4.295226 0.117953514 5.34673036 1.16945788 5.34673036 2.57151877 3.94466948 2.57151877 3.94466948 1.5200144 1.49110423 1.5200144 1.49110423 3.97357965 4.295226 3.97357965 5.34673036 5.02508402 5.34673036 8.53015364 4.295226 9.581658 1.1407129 9.581658 0.08920854 8.53015364 0.08920854 7.12809275 1.49110423 7.12809275 1.49110423 8.17959711 3.94466948 8.17959711 3.94466948 5.37564054 1.1407129 5.37564054 0.08920854 4.32413618 0.08920854 1.16945788 1.1407129 0.117953514"></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const styleSpan = {
  color: "#11bbf5",
};

export default NosPartenaires;
